let loadPromise = null

// Idempotent — safe to call every time the buy-credits modal opens; only
// injects the script tag once, subsequent calls resolve immediately.
export function loadRazorpayCheckoutScript() {
  if (window.Razorpay) return Promise.resolve(true)
  if (loadPromise) return loadPromise

  loadPromise = new Promise(resolve => {
    const script = document.createElement('script')
    script.src = 'https://checkout.razorpay.com/v1/checkout.js'
    script.onload = () => resolve(true)
    script.onerror = () => { loadPromise = null; resolve(false) }
    document.body.appendChild(script)
  })
  return loadPromise
}
